import { render, staticRenderFns } from "./policyTableList.vue?vue&type=template&id=8a150f6e&scoped=true&"
import script from "./policyTableList.vue?vue&type=script&lang=js&"
export * from "./policyTableList.vue?vue&type=script&lang=js&"
import style0 from "./policyTableList.vue?vue&type=style&index=0&id=8a150f6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a150f6e",
  null
  
)

export default component.exports